module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/2/4-88d01e35c7cac8f92a69d5ea8a065522.jpg";